export default function roundQuarter(num) {
  return Math.round(num * 4) / 4;
}
